console.log('affiliate-program custom script :)');